import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogDescription as AlertDialogDescriptionBase } from "./base/AlertDialogBase"

export type AlertDialogDescriptionProps = ComponentProps<
  typeof AlertDialogDescriptionBase
>

function AlertDialogDescription(props: AlertDialogDescriptionProps) {
  const { className, ...alertDialogDescriptionBaseProps } = props

  return (
    <AlertDialogDescriptionBase
      className={cn("ui-alert-dialog-description", className)}
      {...alertDialogDescriptionBaseProps}
    />
  )
}

export default AlertDialogDescription
